<template>

  <div class="modal" :class="{'is-active': true}">
    <div class="modal-background" @click.stop="$store.commit('setShowBalanceTopUpModal', false)"></div>
    <div class="modal-content">
      <div class="box modal-container" style="padding: 30px;">
        <div class="modal-content-root" style="margin-top: 0;">
          <p class="title-font is-size-4 mainColor--text">Purchase {{ $store.getters.whiteGloveFamilyProgramName }} Content Pack</p>
          <div class="mainColor--text message-text">

            <div class="mb-6" style="font-size: 1rem; line-height: 1.6;">Purchasing one of these packs will add the credit to your {{ $store.getters.whiteGloveFamilyProgramName }} Content Balance. Use the credit at any time on any content products and across all projects.</div>

            <div class="d-flex" style="gap: 24px;">

              <div style="flex: 1;">
                <div
                  v-for="option in AVAILABLE_BALANCE_TOP_UP_OPTIONS" :key="option.key"
                  :class="{
                    'top-up-option': true,
                    'active': selectOption?.key === option.key
                  }"
                  @click="selectOption = {...option}"
                >
                  <div v-if="selectOption?.key === option.key" class="active-icon"><div></div></div>
                  <div v-else class="inactive-icon"></div>
                  <div style="font-weight: 700; text-transform: uppercase; font-size: 1rem;">
                    {{ formatCurrency(option.top_up_amount) }} USD
                  </div>
                </div>
              </div>

              <div class="d-flex" style="flex: 1; flex-direction:column; gap:12px;">
                <div style="flex: 1;">

                  <div
                    v-if="preferredCard && !isMissionControlSession"
                    class="d-flex align-center justify-space-between gap10 mb-4"
                    style="padding: 10px; border-radius: 4px; border: 1px solid #CCCCCC;"
                  >
                    
                    <div class="pl-2" style="font-weight: 700; font-size: 1rem;">
                      Payment
                    </div>
                    
                    <div class="d-flex align-center gap5">
                      <div style="font-size: 0.9rem; font-weight: 700;">
                        <template v-if="preferredCard.brand == 'visa'">
                          <img src="/static/visa.png" width="40px" />
                        </template>
                        <template v-else-if="preferredCard.brand == 'mastercard'">
                          <img src="/static/mastercard.png" width="40px" />
                        </template>
                        <template v-else>
                          {{ preferredCard.brand }}
                        </template>
                      </div>
                      <div style="font-size: 0.8rem; font-weight: 700;">
                        ••••
                      </div>
                      <div style="font-size: 0.9rem; font-weight: 700;">
                        {{ preferredCard.last4 || '' }}
                      </div>
                    </div>

                    <v-tooltip top color="black">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn outlined
                          small
                          color="grayColor" class="button-with-icon text-none" style="min-width: initial; padding: 0 4px;"
                          @click="$router.push(`/useraccount/${user.id}?mainTab=billing-and-payments&subTab=credit-cards`); $store.commit('setShowBalanceTopUpModal', false);"
                          v-bind="attrs" v-on="on"
                        >
                          <i class="material-icons-outlined" style="font-size: 1.1rem; color: var(--v-gray2Color-base);">edit</i>
                        </v-btn>
                      </template>
                      <div>Edit</div>
                    </v-tooltip>
                  </div>

                  <div class="mb-2 d-flex align-center gap5">
                    <i class="material-icons" style="color: #00BC5E;">check</i>
                    <div>This is not a recurring subscription fee</div>
                  </div>
                  <div class="mb-2 d-flex align-center gap5">
                    <i class="material-icons" style="color: #00BC5E;">check</i>
                    <div>Credits do not expire</div>
                  </div>

                  <b-dropdown
                    v-if="isMissionControlSession"
                    aria-role="list" @click.native.stop
                    class="mt-4 sales-tag-dropdown"
                  >
                    <template #trigger>
                      <v-btn
                        style="min-width: 110px;"
                        class="sales-tag-btn"
                        small
                        :color="ownerUser.next_balance_purchase_sales_tag === 'active' ? 'success' : undefined"
                      >
                        <template v-if="ownerUser.next_balance_purchase_sales_tag === 'passive'">Passive sale</template>
                        <template v-else-if="ownerUser.next_balance_purchase_sales_tag === 'active'">Active sale</template>
                        <template v-else-if="!ownerUser.next_balance_purchase_sales_tag">-</template>
                        <template v-else>{{ ownerUser.next_balance_purchase_sales_tag }}</template>
                      </v-btn>
                    </template>
                    <b-dropdown-item :disabled="ownerUser.next_balance_purchase_sales_tag === 'passive'" aria-role="listitem" @click.native.stop="updateUser({next_balance_purchase_sales_tag: 'passive'})">Set as passive sale</b-dropdown-item>
                    <b-dropdown-item :disabled="ownerUser.next_balance_purchase_sales_tag === 'active'" aria-role="listitem" @click.native.stop="updateUser({next_balance_purchase_sales_tag: 'active'})">Set as active sale</b-dropdown-item>
                  </b-dropdown>
                </div>

                <div>

                  <div v-if="selectOption.top_up_bonus" class="mb-3 d-flex align-center gap5">
                    <div style="font-weight: 700; font-size: 0.9rem;">Bonus value: {{ formatCurrency(selectOption.top_up_bonus) }} USD</div>
                    <v-tooltip top color="transparent">
                      <template v-slot:activator="{ on, attrs }">
                        <i class="material-icons" style="color: var(--v-gray9Color-base);" v-bind="attrs" v-on="on">info</i>
                      </template>
                      <div class="white-bg-tooltip small-tooltip">
                        Get more for your money - you’ll get an extra {{ formatCurrency(selectOption.top_up_bonus) }} added to your balance automatically.
                      </div>
                    </v-tooltip>
                  </div>

                  <v-btn
                    v-if="isMissionControlSession"
                    block color="profileAnchorColor"
                    class="whiteColor--text text-none mb-2"
                    @click="addToCart()"
                  >
                    <span style="font-weight: 800; font-size: 0.9rem;">Add to cart</span>
                  </v-btn>
                  <v-btn
                    v-if="isMissionControlSession"
                    block color="profileAnchorColor"
                    class="whiteColor--text text-none"
                    @click="showSendInvoiceConfirmModal = true"
                  >
                    <span style="font-weight: 800; font-size: 0.9rem;">Send invoice to user</span>
                  </v-btn>
                  <v-btn v-else block color="profileAnchorColor"
                    class="whiteColor--text text-none"
                    @click="buyNow()"
                  >
                    <span style="font-weight: 800; font-size: 0.9rem;">Buy now</span>
                  </v-btn>

                </div>

              </div>

            </div>

          </div>
        </div>

        <div
          v-if="showSendInvoiceConfirmModal && isMissionControlSession"
          class="modal"
          :class="{
            'is-active': true,
          }"
        >
          <div
            class="modal-background"
            @click="
              showSendInvoiceConfirmModal = false
            "
          ></div>
          <div class="modal-content">
            <div class="box modal-container">
              <div class="pad25">
                <div>
                  <div
                    class="mainColor--text font-weight-bold mb-5"
                    style="font-size: 20px"
                  >
                    Are you sure?
                  </div>
                  <div
                    class="mainColor--text mb-5"
                    style="font-size: 16px; line-height: 24px"
                  >
                    You are about to send an invoice by email to the user's billing email (<b style="font-size: 16px; line-height: 24px">{{ selectedSubAccountRelation?.agencyInvoicingEmail || selectedSubAccountRelation?.agencyUserEmail }}</b>).
                    <br /><br />
                    Are you sure you want to proceed?
                  </div>
                </div>
                <div class="text-right">
                  <v-btn
                    rounded
                    color="profileAnchorColor"
                    class="button-with-icon whiteColor--text text-none ml-2"
                    @click="buyNow('invoice')"
                  >
                    <span>Yes, send invoice</span>
                  </v-btn>
                  <v-btn
                    rounded
                    outlined
                    color="mainColor"
                    class="button-with-icon mainColor--text text-none ml-2"
                    @click="
                      () => {
                        showSendInvoiceConfirmModal = false;
                      }
                    "
                  >
                    <span>Cancel</span>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <button
        class="custom-modal-close-btn"
        aria-label="close"
        @click="$store.commit('setShowBalanceTopUpModal', false)">
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>

</template>

<script>
import { AVAILABLE_BALANCE_TOP_UP_OPTIONS } from "@/components/plans_constants"
import { formatCurrency } from '@/utils'

export default {
  props: [],
  components: {

  },
  data() {
    return {
      AVAILABLE_BALANCE_TOP_UP_OPTIONS: AVAILABLE_BALANCE_TOP_UP_OPTIONS,
      selectOption: {...AVAILABLE_BALANCE_TOP_UP_OPTIONS[2]},
      preferredCard: null,
      showSendInvoiceConfirmModal: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    selectedSubAccountRelation () {
      return this.$store.state.selectedSubAccountRelation
    },
    ownerUser() {
      return this.$store.state.selectedSubAccountRelation || this.$store.state.user
    },
    isMissionControlSession () {
      return this.$store.state.selectedSubAccountRelation?.isMissionControlSubAccount
    },
  },
  methods: {
    formatCurrency: formatCurrency,
    loadPaymentSources() {
      this.preferredCard = null;
      return this.$store.dispatch('loadUserHasPaymentSources').then(
        response => {
          if (response.data && response.data.status === "SUCCESS") {
            if (response.data.hasPaymentSource) {
              return this.$store.dispatch('fetchPaymentSources').then((response) => {
                if (response.data.status == 'SUCCESS') {
                  const preferredCard = response.data.cards.find(card => card.preferred)
                  this.preferredCard = preferredCard
                }
              })
            }
          }
        }
      )
    },
    reloadUser() {
      // reload user to update ui with any credit usage
      return this.$store.dispatch("loadUser").then(response => {
        this.$store.commit("setUser", response.data.user);
      });
    },
    updateUser(payload) {
      return this.$store.dispatch('updateUser', {
        userId: this.ownerUser?.ownerId || this.user.id,
        body: payload
      })
        .then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            return this.reloadUser()
          }
        })
    },
    addToCart() {
      this.$store.commit('showLoading');
      return this.$store.dispatch('createBalanceTopUpOrder', {
        body: {
          key: this.selectOption.key,
        }
      })
      .then(response => {
        if (response.data && response.data.status == 'SUCCESS') {
          this.$notify({
            group: 'info', type: 'success',
            text: 'Added to cart'
          })
          this.$store.commit('triggerRefreshSiloContentReportsOrdersCart', true);
          this.$emit('close');
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading');
      })
    },
    buyNow(mode='checkout') {
      this.$store.commit('showLoading');
      this.$store.dispatch('createStripePayment', {
        packageType: 'BALANCE_TOP_UP',
        selectedPackage: this.selectOption.key,
        userID: this?.selectedSubAccountRelation?.ownerId || this.user.id,
        items: [
          {
            'type': 'balance_top_up_order',
            'key': this.selectOption.key
          }
        ],
        mode,
        // promoCode: this.appliedCoupon?.code,
      })
      .then((response) => {
        if (response.data.url) {
          window.open(response.data.url, '_self')
        } else if (mode === 'invoice' && response.data.status === 'SUCCESS') {
          this.$notify({
            group: 'info', type: 'success',
            text: 'Invoice sent to user'
          })
          this.showSendInvoiceConfirmModal = false;
        }
      })
      .finally(() => {
        this.$store.commit('hideLoading');
      })
    },
  },
  mounted () {
    this.loadPaymentSources()
  }
};
</script>

<style lang="scss" scoped>
.top-up-option {
  display:flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 14px;
  border-radius: 4px;
  border: 1px solid #CCCCCC;
  background-color: #ffffff;
  cursor: pointer;
  color: #014751;

  &:last-child {
    margin-bottom: 0;
  }

  &.active {
    border-color: #FF5C00;
    background-color: #FFF4EE;
  }

  .active-icon {
    display: inline-flex;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    border: 2px solid #FF5C00;
    align-items: center;
    justify-content: center;

    div {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      background-color: #FF5C00;
    }
  }

  .inactive-icon {
    display: inline-flex;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    border: 1px solid #CCCCCC;
    align-items: center;
    justify-content: center;
  }
}

.sales-tag-dropdown {
  .dropdown-item {
    font-weight: normal;
  }

  &.is-disabled {
    opacity: initial;
    cursor: default;
  }
}

.sales-tag-btn {
  text-transform: initial;
  letter-spacing: initial;
}
</style>
